/* eslint-disable max-len */
const SaleStandardJSON = {
  wizardName: 'Sale (Standard)',
  wizardDescription: 'Standard sale deal template',
  items: [
    {
      name: 'Title',
      type: 'string',
      required: true,
      displayName: 'Deal Name',
    },
    {
      name: 'Description',
      type: 'string',
      required: false,
      displayName: 'Description',
    },
    {
      name: 'SellerName',
      type: 'contact',
      required: true,
      displayName: 'Seller',
      width: 50,
    },
    {
      name: 'BuyerName',
      type: 'contact',
      required: true,
      displayName: 'Buyer',
      width: 50,
    },
    {
      name: 'AgentContactName',
      type: 'agent',
      required: true,
      displayName: 'Agent',
      width: 50,
    },
    {
      name: 'ClosingDate',
      type: 'date',
      required: true,
      displayName: 'Closing Date',
      width: 50,
    },
    {
      name: 'COMM',
      type: 'dollar',
      displayName: 'Commission Amount',
      width: 50,
    },
    {
      name: 'ESCROW_AMOUNT',
      type: 'dollar',
      displayName: 'Escrow Amount',
      width: 50,
    },
    {
      name: 'StatusName',
      type: 'enum',
      required: true,
      displayName: 'Deal Status',
      enumOptions: ['Draft', 'Submitted', 'Approved'],
      width: 50,
    },
  ],
  wizard: [
    {
      name: 'SCOM',
      required: true,
      displayName: 'Sale Commission Category',
      type: 'tranCategory',
      prompt:
        'Select a transaction category that represents the Commission you are paying to an agent.  Typically this category is "SCOM - Sale Commission"',
    },
    {
      name: 'ESCR',
      required: true,
      displayName: 'Escrow Category',
      type: 'tranCategory',
      prompt: 'Select an Escrow category',
    },
  ],
  template: {
    Deals: [
      {
        Title: '$Title',
        DealNumber: 'AUTO-GENERATE',
        AgentContactName: '$AgentContactName',
        Description: '$Description',
        ContractDate: '$ContractDate',
        TransactionDate: '$TransactionDate',
        BillableDate: '$TransactionDate',
        PayableDate: '$TransactionDate',
        StatusName: '$StatusName',
      },
    ],
    DealTransactions: [
      {
        DealTitle: '$Title',
        Price: '$COMM * %AGENT_SALE_SPLIT',
        TranType: 'AP',
        TranCategoryId: '#SCOM',
        ContactName: '$AgentContactName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$COMM',
        TranType: 'AR',
        TranCategoryId: '#SCOM',
        ContactName: '$BuyerName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$ESCROW_AMOUNT',
        TranType: 'AP',
        TranCategoryId: '#ESCR',
        ContactName: '$SellerName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$ESCROW_AMOUNT',
        TranType: 'AR',
        TranCategoryId: '#ESCR',
        ContactName: '$BuyerName',
        Quantity: 1,
        Description: '$Description',
      },
    ],
  },
};

export { SaleStandardJSON };
